import { observable } from 'mobx';
import _ from 'lodash';
import lscache from 'lscache';
import desovaPierService from '../../../services/DesovaPierService';
import ValidacaoStore from '../../../modules/comum/stores/ValidacaoStore';
import { urlApi } from '../../../config/Constantes';

class DesovaPierController {
    
    @observable salvando;
    @observable salvarConcluido;
    
    @observable modalConfig;
    
    @observable erroValidacao;
    @observable mensagemErro;
    @observable mensagemSucesso;
    @observable mensagemNcmBloqueado;
    @observable mensagemCrossdoking;
    
    @observable carregandoRazao;
    @observable carregandoNCM;
    
    @observable erroBL;
    @observable erroCE;
    @observable erroEmail;
    @observable erroViagem;
    @observable erroCNPJ;
    @observable erroObservacao;
    @observable erroRazao;
    @observable erroTermo;
    @observable erroConteiner;
    @observable erroConteineres;
    @observable erroArquivos;

    constructor() {
        this.salvando = false;
        this.validacaoStore = new ValidacaoStore();
        this.carregandoNCM = false;
        this.carregandoRazao = false;

        this.salvarConcluido = false;

        this.download = document.createElement('a')
        document.body.appendChild(this.download)
        this.download.style = 'display: none'
        this.download.target = '_blank'

        this.mensagemSucesso = null;
        this.mensagemNcmBloqueado = 'Não é possível desovar cargas deste NCM.';
        this.mensagemCrossdoking = null;
        
        this.modalConfig = {
            tipoModal: undefined,
            modalTitulo: undefined,
            labelCancelar: undefined,
            labelConfirmar: undefined,
            onClickSalvar: undefined,
        };
        
        this.mensagemErroPadrao = 'Ocorreu um erro. Não foi possível completar essa ação no momento.';

        this.clearErrors();

    };

    clearErrors = () => {
        this.erroValidacao = null;
        this.mensagemErro = null;
        this.mensagemErroPadrao = 'Ocorreu um erro. Não foi possível completar essa ação no momento.';
        
        this.erroBL = null;
        this.erroCE = null;
        this.erroEmail = null;
        this.erroViagem = null;
        this.erroCNPJ = null;
        this.erroObservacao = null;
        this.erroRazao = null;
        this.erroTermo = null;
        this.erroConteiner = null;
        this.erroConteineres = null;
        this.erroArquivos = null;
    }

    configurarModalFinalizar = (cb) => {
        this.salvarConcluido = true;
        this.modalConfig = {
            tipoModal: 'Finalizar',
            modalTitulo: 'Salvo com sucesso!',
            labelConfirmar: '',
            labelCancelar: 'FECHAR',
            onClickSalvar: () =>  cb && cb(),
        };
    };

    configurarModalCancelar = (cb) => {
        this.salvarConcluido = true;
        this.modalConfig = {
            tipoModal: 'Cancelar',
            modalTitulo: 'Deseja cancelar essa solicitação?',
            labelConfirmar: 'SIM',
            labelCancelar: 'NÃO',
            onClickSalvar: async (solicitacao) => {
                await desovaPierService.inativarSolicitacao(solicitacao.Id)
                cb && cb();
            },
        };
    };

    configurarModalCadastrar = () => {
        this.salvarConcluido = false;
        this.modalConfig = {
            tipoModal: 'Cadastrar',
            modalTitulo: 'Solicitar Desova Pier',
            labelConfirmar: 'CONFIRMAR SOLICITAÇÃO',
            labelCancelar: 'CANCELAR',
            onClickSalvar: (solicitacao) => this.salvarSolicitacao(solicitacao)
        };
    };

    configurarModalEditar = (id) => {
        this.salvarConcluido = false;
        this.modalConfig = {
            tipoModal: 'Editar',
            modalTitulo: `Editar Solicitação #${id}`,
            labelConfirmar: 'CONFIRMAR ALTERAÇÃO',
            labelCancelar: 'CANCELAR',
            onClickSalvar: (solicitacao) => this.salvarSolicitacao(solicitacao)
        };
    };

    configurarModalEditarAnexos = () => {
        this.salvarConcluido = false;
        this.modalConfig = {
            tipoModal: 'anexos',
            modalTitulo: 'Editar Anexos',
            labelConfirmar: 'CONFIRMAR ALTERAÇÃO',
            labelCancelar: 'CANCELAR',
            onClickSalvar: (solicitacao) => {
                this.salvarAnexos(solicitacao.Arquivos, solicitacao.Id)
                this.configurarModalFinalizar();
            }
        };
    };

    configurarModalVisualizar = (id) => {
        this.salvarConcluido = false;
        this.modalConfig = {
            tipoModal: 'visualizar',
            modalTitulo: `Visualizar Solicitação #${id}`,
            labelConfirmar: '',
            labelCancelar: 'FECHAR',
            onClickSalvar: () => null,
        };
    };

    carregarNCM = (documento) => {
        this.carregandoBL = true;
        this.erroBL = null;
        this.mensagemCrossdoking = false;
        if (typeof (documento) != 'undefined') {
            return desovaPierService.carregarPorNcm(documento).then(response => {
                if (response && response.data) {
                    if (response.data.Restrito)  this.mensagemCrossdoking = true; 
                    if (response.data.Bloqueado)  this.erroBL = this.mensagemNcmBloqueado 
                    return { CE: response.data.Ce, IdDocumento: response.data.Id }
                } else {
                    return Promise.reject();
                }
            })
                .catch(error => {
                    console.log(error);
                    // this.erroBL = 'BL não encontrado';
                    return {CE:'', IdDocumento: 0}
                })
                .finally(() => {
                    this.carregandoNCM = false;
                });

        } else {
            this.erroBL = 'Preencha o campo BL';
            this.carregandoNCM = false;
            return {CE:'', IdDocumento: 0}
        }
    };

    carregarCnpj = async (cnpj) => {
        this.carregandoRazao = true;
        this.erroCNPJ = null;
        this.mensagemCrossdoking = null;

        if (typeof (cnpj) != 'undefined' && cnpj != '') {
            try {
                const response = await desovaPierService.carregarPorCnpj(cnpj);

                if (response && response.data) {
                    this.mensagemCrossdoking = response.data.Restrito ? true : false;
                    if (response.data.Bloqueado)  this.erroCNPJ = this.mensagemNcmBloqueado
                    this.carregandoRazao = false;
                    return response.data
                }
                this.erroCNPJ = 'Cliente não cadastrado';
                this.carregandoRazao = false;
                return { Razao: ''};
            } catch (error) {
                console.log(error)
                this.carregandoRazao = false;
                return { Razao: ''};
            }
        } else {
            this.erroCNPJ = 'Preencha o campo CNPJ';
            this.carregandoRazao = false;
            return { Razao: ''};
        }
    };

    adicionarUnidade = (conteiner, list) => {

        const regex = /[A-Z]{3}U[0-9]{7}/gm;

        if(typeof(conteiner) == 'undefined' || conteiner === '') {
            this.erroConteiner = `Campo conteiner precisa ser preenchido`;
            return null;
        }

        if (conteiner.toUpperCase().match(regex) && conteiner.length === 11) {
            const formatedConteiner = {
                Id: 0,
                Numero: conteiner.toUpperCase(),
                DesovaId: 0
            }
            const containerWasAdded = list.find(item => item.Numero == conteiner.toUpperCase())
            if (containerWasAdded) {
                this.erroConteiner = `${conteiner.toUpperCase()} já foi adicionado à lista.`;
                return null;
            }

            list.push(formatedConteiner);
            this.erroConteiner = null;
            return list;
        } else {
            this.erroConteiner = `${conteiner.toUpperCase()} não está no padrão XXXU9999999`;
            return null;
        }
    };

    validarCampos = (solicitacao) => {
        this.mensagemErro = null;
        this.falhaValidacao = false;

        if (!solicitacao.BL) {
            this.erroBL = 'Campo obrigatório'
        } else {
            // Eu não posso sempre limpar o campo de mensagem para NCM
            // só posso fazer isso se ele for preenchido corretamente e a mensagem ainda for 'Campo obrigatório'
            // já que há outras possíveis mensagens
            if (this.erroBL === 'Campo obrigatório') this.erroBL = null;
        }
        if(!solicitacao.CE) {
            this.erroCE = 'Campo obrigatório';
        } else {
            if (solicitacao.CE.length !== 15) {
                this.erroCE = 'Campo CE deve conter 15 números.';
            } else {
                this.erroCE = null;
            }
        }
        if (!solicitacao.Email) {
            this.erroEmail = 'Campo obrigatório'
        } else {
            this.erroEmail = null;
            //TODO criar validação que aceita entrada com espaços
            const emails = (solicitacao.Email).split(',')
            emails.map(email => {
                if (!(this.validacaoStore.isEmail(email))) {
                    this.erroEmail = 'Insira um endereço de email válido'
                }
            });
            
        }
        if (!solicitacao.Viagem) {
            this.erroViagem = 'Campo obrigatório';
        }
        if (!(solicitacao.CNPJ)) {
            this.erroCNPJ = 'Campo Obrigatório'
        } else {
            if (this.erroCNPJ === 'Campo obrigatório') this.erroCNPJ = null;
        }
        if (solicitacao.FlagTerno === false) {
            this.erroTermo = 'Obrigatório aceitar o termo';
        } else {
            this.erroTermo = null;
        }

        if (solicitacao.Conteineres && solicitacao.Conteineres.length === 0) {
            this.mensagemErro = 'É obrigatória a inclusão de Conteineres para a solicitação de Desova Pier.';
            this.erroConteineres = 'Incluir conteineres';
        } else {
            this.erroConteineres = null;
        }

        if (this.erroBL || 
            this.erroCE ||
            this.erroEmail ||
            this.erroViagem ||
            this.erroCNPJ ||
            this.erroTermo ||
            this.erroConteineres
        ) {
            this.falhaValidacao = true;
        }

    }; 

    salvarSolicitacao = async (solicitacao) => {
        this.salvando = true;

        this.validarCampos(solicitacao);
        
        if (this.falhaValidacao) {
            this.erroValidacao = 'Preencha todos os campos corretamente';
            this.salvando = false;
            return;
        }
        try {
            const response = await desovaPierService.persistirSolicitacao(solicitacao);
            if (response && response.data) {
                if (response.data.Sucesso) {
                    const anexosResponse = await this.salvarAnexos(solicitacao.Arquivos, response.data.Id);
                    console.log(anexosResponse);
                    this.configurarModalFinalizar();
                } else {
                    this.mensagemErro = response.data.Mensagem || response.data.MensagemErro;
                }
            } else {
                this.mensagemErro = this.mensagemErroPadrao;
            }
        } catch (error) {
            this.mensagemErro = error ? error : this.mensagemErroPadrao;
        }
        this.erroValidacao = null;
        this.salvando = false;
    };

    
    anexarArquivo = (arquivos) => {
        return Array.from(arquivos.target.files).map((arqv, index) => {
            let filename = arqv.name.replace(/[^a-zA-Z0-9\.]/g, '');
            filename = filename.split('.')[0];

            return { Id: 0, file: arqv, Nome: filename, Extensao: arqv.name.split('.').pop() };
        })
    };

    salvarAnexos = async (anexos, solicitacaoId) => {
        return await Promise.all(anexos.map(async (arquivo) => {
            if(arquivo.Id !== 0) return arquivo;
            let arqv = new FormData()
            arqv.append('file', arquivo.file);

            const response = await desovaPierService.salvarAnexo(arqv, arquivo.Extensao, arquivo.Nome, solicitacaoId)

            if (response && response.data) {
                if (response.data.Sucesso) {
                    arquivo.Id = response.data.Id
                    return arquivo
                } else {
                    Promise.reject(response.data.Mensagem || response.data.MensagemErro);
                }
            }
        }))
    };

    baixarArquivo = (listaAnexos, index, id) => {
        if (!id) {
            const anexo = listaAnexos[index];
            const file = new File([listaAnexos[index].file], `${anexo.Nome}.${anexo.Extensao}`, { type: 'application/octet-stream' })
            this.gerarLinkDownload(file, anexo)
        } else {
            const anexo = listaAnexos.find(anexo => anexo.Id === id)
            
            fetch(`${urlApi}/SolicitacaoDesovaPier/baixar-arquivo?idArquivo=${id}`).then(res => {
                if (res.status !== 200) {
                    this.mensagemErro = "Não foi possível completar o download";
                } else {
                    return res.blob();
                }
            }).then(blob => 
                this.gerarLinkDownload(blob, anexo)
            ).catch(err => { 
                console.error(err); 
                this.mensagemErro = "Erro ao fazer o download" 
            })
        }
    }

    gerarLinkDownload = (file, anexo) => {
        const url = window.URL.createObjectURL(file)
        this.download.href = url
        this.download.download = `${anexo.Nome}.${anexo.Extensao}`
        this.download.click()
        window.URL.revokeObjectURL(url)
    }

}

export default new DesovaPierController();


// WEBPACK FOOTER //
// ./src/modules/desova-pier/stores/DesovaPierController.js